import React, { useEffect, useState } from 'react';
import { getDocs, collection, query, where } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { db } from '../../firebaseConfig';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer';
import FooterTop from '../../components/footer-top';
import { formatAddress, formatAddressForMaps } from '../../utils/addressUtils';

interface Proyecto {
  id: string;
  nombre: string;
  area_m2: number;
  direccion: string;
  inmobiliaria_id: string;
  amenidades?: string[];
  nombreInmobiliaria?: string;
}

export default function ListaProyectos() {
  const [proyectos, setProyectos] = useState<Proyecto[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProyectos = async () => {
      try {
        const snap = await getDocs(collection(db, 'proyectos'));
        const proyectosData = snap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })) as Proyecto[];

        const enriched = await Promise.all(
          proyectosData.map(async (proj) => {
            let nombreInmobiliaria = 'Desconocida';

            if (proj.inmobiliaria_id) {
              const q = query(
                collection(db, 'inmobiliaria'),
                where('inmobiliaria_id', '==', proj.inmobiliaria_id) // ✅ CORRECTO ahora
              );
              const inmSnap = await getDocs(q);
              if (!inmSnap.empty) {
                nombreInmobiliaria = inmSnap.docs[0].data().nombre;
              }
            }

            return { ...proj, nombreInmobiliaria };
          })
        );

        setProyectos(enriched);
      } catch (error) {
        console.error('Error al obtener proyectos:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProyectos();
  }, []);

  if (loading) return <p className="text-center mt-5">Cargando proyectos...</p>;

  return (
    <>
      <Navbar transparent={false} />

      <div className="container my-5">
        <h2 className="mb-4">Lista de Proyectos</h2>

        {proyectos.length > 0 ? (
          <div className="row">
            {proyectos.map((p, i) => (
              <div key={i} className="col-md-6 mb-4">
                <div className="card p-3 shadow-sm">
                  <h5 className="mb-2">{p.nombre}</h5>
                  <p><strong>Área:</strong> {p.area_m2} m²</p>
                  <p><strong>Inmobiliaria:</strong> {p.nombreInmobiliaria}</p>
                  <p>
                    <strong>Dirección:</strong>{' '}
                    <a href={formatAddressForMaps(p.direccion)} target="_blank" rel="noopener noreferrer">
                      {formatAddress(p.direccion)}
                    </a>
                  </p>
                  <Link to={`/view-project/${p.id}`} className="btn btn-primary btn-sm mt-2">
                    Ver Detalles
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No hay proyectos registrados.</p>
        )}
      </div>

      <FooterTop bg="theme-bg" />
      <Footer />
    </>
  );
}
